const fa = {
	acceptRules: 'قوانین را تایید کنید',
	activityType: 'نوع فعالیت',
	cancel: 'انصراف',
	clear: 'پاک کردن',
	columns: 'ستون‌ها',
	contractFile: 'فایل قرارداد',
	date: 'تاریخ',
	dateAndTime: 'تاریخ و ساعت',
	dateIsNotEntered: 'تاریخ وارد نشده است',
	delete: 'حذف',
	download: 'دانلود',
	downloadExcelNotice: 'توجه داشته باشید اکسل دانلود شده شامل محتوایی است که شما در حال مشاهده آن می‌باشید.',
	failedToGetInformation: 'دریافت اطلاعات با مشکل مواجه شد',
	female: 'زن',
	fileInvalidSizeDescription: 'حجم فایل نباید بزرگتر از {{field}} مگابایت باشد.',
	fileInvalidType: 'نوع فایل نامعتبر است',
	fileInvalidTypeDescription: 'نوع فایل باید {{field}} باشد.',
	gender: 'جنسیت',
	getExcel: 'دریافت اکسل',
	ip: 'آی پی',
	male: 'مرد',
	maxDateExceeds: 'حداکثر تاریخ مجاز برای انتخاب {{field}} است',
	minDateExceeds: 'حداقل تاریخ مجاز برای انتخاب {{field}} است',
	name: 'نام',
	off: 'خاموش',
	ok: 'تایید',
	on: 'روشن',
	rial: ' ریال',
	status: 'وضعیت',
	successful: 'موفق',
	time: 'ساعت',
	to: 'تا',
	unSuccessful: 'ناموفق',
	uploadServiceNotFound: 'سرویس بارگذاری یافت نشد!',
	view: 'مشاهده',
	yourActivityReport: 'گزارش فعالیت شما',
	province: 'استان',
	city: 'شهر',
	toman: 'تومان',
	doller: 'دلار',
	password : 'پسورد',
	inValidMobile: 'موبایل معتبر نیست',
	mobileNumber : 'موبایل',
	required: '{{field}} اجباری',
	min: '{{field}} حداقل باید {{min}} کارکتر باشد',
	max: '{{field}} حداکثر باید {{max}} کارکتر باشد',
	mobileLength: 'شماره موبایل باید {{field}} رقم باشد',
	mobile: 'موبایل',
	formatOfPhone: 'نحوه وارد کردن شماره باید به صورت ********-*** باشد',
	telephoneStatic: 'تلفن ثابت',
	inValidNationalId: 'شناسه ملی صحیح نیست',
	nationalId: 'شناسه ملی',
	inValidLegalId: 'شناسه شرکت صحیح نیست',
	legalId: 'شناسه شرکت',
	inValidSheba : 'شماره شبا صحیح نیست',
	sheba : 'شماره شبا',
	mustContainAtleastUppercase: 'پسورد باید حداقل شامل {{length}} حرف بزرگ باشد',
	mustContainAtleastLowercase: 'پسورد باید حداقل شامل {{length}} حرف کوچک باشد',
	mustContainAtleastMinNumbers: 'پسورد باید حداقل شامل {{length}} عدد باشد',
	mustContainAtleastMinSymbols: 'پسورد باید حداقل شامل {{length}} کارکتر خاص باشد',
	mustContainAtleastMinRepeating: 'پسورد نباید بیشتر از {{length}} کارکتر تکراری داشته باشد',
	mustContainAtleastMinWords: 'پسورد باید حداقل شامل {{length}} کلمه باشد',
	mustEnglishCharcter: 'پسورد باید ترکیبی از حروف لاتین ،اعداد و کارکتر خاص باشد',
	edit: 'ویرایش',
	enName: 'نام به لاتین',
};

export default fa;
